import axios from "axios";
import { storage } from './storage';
import echo from "./echo";

import packageJson from "../../package.json";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json"
    },
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = storage.get('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`; 
        }

        const socketId = echo.socketId();
        if (socketId) {
            config.headers['X-Socket-ID'] = socketId;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        const appVersion = response.headers["x-app-version"];

        if (appVersion && appVersion !== packageJson.version) {
            window.location.reload();
        }

        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');

            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
